// extracted by mini-css-extract-plugin
export default {"name":"Name_name__ORJ+n"};